// extracted by mini-css-extract-plugin
module.exports = {"card":"InvestEtFsCards_card__MVmDc","title":"InvestEtFsCards_title__xl7Nk","content":"InvestEtFsCards_content__X_C_t"};